module.exports = __webpack_public_path__ + "static/media/left-arrow-black.4ce05dac.svg";